import { CheckCheck } from "lucide-react";
import { cn } from "@/utils/cn";

export interface MarkAllReadButtonProps {
  onClick: () => void;
  className?: string;
}

function MarkAllReadButton({
  onClick,
  className = "",
}: MarkAllReadButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex items-center gap-1 rounded-md px-1.5 py-1 text-xs font-semibold text-text-secondary hover:bg-surface-muted hover:text-text-primary",
        className
      )}
    >
      <CheckCheck size={13} />
      Mark all read
    </button>
  );
}

export default MarkAllReadButton;
